import { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  updateCreateOrderOption,
  updateOrderDirection,
} from 'store/spot/actions'
import {
  useSpotOrderDirection,
  useSpotSelectedOrderMode,
} from 'store/spot/hooks'
import { OrderDirection, OrderType } from 'store/spot/types'
import { styled } from '@mui/material'
import { transientOptions } from 'styles/TransientOptions'
import clsx from 'clsx'

export const DirectionTabsWrap = styled('div')`
  display: flex;
  height: 32px;
  margin-bottom: 16px;
  border-radius: 16px;
  background-color: rgba(42, 49, 57, 1);
  color: rgba(149, 164, 173, 1);
  position: relative;

  /* ${(props) => props.theme.breakpoints.down('md')} {
    flex: 1;
    margin-right: 57px;
    margin-bottom: unset;
  } */
`
export const Background = styled('div')`
  position: absolute;
  left: 0;
  top: 0;
  width: 50%;
  height: 100%;
  border-radius: 16px;
  transition: all 0.2s ease-in-out;

  &.buy {
    background-color: rgba(20, 71, 56, 1);
    left: 0;
  }
  &.sell {
    background-color: rgba(85, 38, 48, 1);
    left: 50%;
  }
`
export const DirectionTabItem = styled('div', transientOptions)<{
  $active: boolean
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 16px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
`

export const BuyItem = styled(DirectionTabItem)`
  color: ${({ $active }) => ($active ? 'rgba(14, 203, 129, 1)' : 'inherit')};
`
export const SellItem = styled(DirectionTabItem)`
  color: ${({ $active }) => ($active ? 'rgba(246, 70, 93, 1)' : 'inherit')};
`

export const DirectionTabs = memo(() => {
  const dispatch = useDispatch()
  const orderDirection = useSpotOrderDirection()
  const spotSelectOrderType = useSpotSelectedOrderMode()

  useEffect(() => {
    if (spotSelectOrderType.orderType !== OrderType.MARKET) {
      dispatch(updateCreateOrderOption({ option: 'limitPrice', value: '' }))
    }
    dispatch(
      updateCreateOrderOption({ option: 'baseCurrencyAmount', value: '' }),
    )
    dispatch(
      updateCreateOrderOption({ option: 'quoteCurrencyAmount', value: '' }),
    )
  }, [dispatch, orderDirection, spotSelectOrderType])

  return (
    <DirectionTabsWrap>
      <Background
        className={clsx({
          buy: orderDirection === OrderDirection.LONG,
          sell: orderDirection === OrderDirection.SHORT,
        })}
      />
      <BuyItem
        id="zk_buy_button"
        $active={orderDirection === OrderDirection.LONG}
        onClick={() => {
          dispatch(updateOrderDirection(OrderDirection.LONG))
        }}
      >
        Buy
      </BuyItem>
      <SellItem
        $active={orderDirection === OrderDirection.SHORT}
        onClick={() => {
          dispatch(updateOrderDirection(OrderDirection.SHORT))
        }}
      >
        Sell
      </SellItem>
    </DirectionTabsWrap>
  )
})
